<template>
	<span :style="'z-index:'+(open?3:2)">
		<button name="Calendar_Open" :class="button?'action':'link'" type="button" @click="openCalendar"><slot>Book Online</slot></button>
		<div class="cal_container" v-if="open" @click.self="open = false">
			<div class="bg-tw-dark-modal fixed w-full h-screen pointer-events-none top-0 left-0">

			</div>
			<div class="calendar_panel">
				<div class="text-melon z-10 absolute left-0 top-0 transform t:-translate-y-1/2 cursor-pointer" @click="open = false">
					<svg class="w-1.5 h-1.5 fill-current inline-block" name="closeCalendar" width="24" height="24" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(45 -35.355 85.355) scale(14)"><circle r="3" stroke="#fff" stroke-width=".5"/><path fill="#fff" d="M-2-.5h4v1h-4z"/><path fill="#fff" d="M-.5-2h1v4h-1z"/></g></svg>
				</div>
				<div class="ranges">
					<p class="text-center m0 text-charcoal f8 l0-2 font-read mb-1/8">Travel Date Range{{ ranges.length==1?'':'s' }}</p>
					<div class="m:max-h-[3.5rem] max-h-[6.2rem] overflow-y-auto">
						<ul class="list-none p-0 m-0 mb-1/2 text-center">
							<li class="l0-3" v-for="range in ranges">
								<button class="border-0 bg-transparent text-plum f8 l0-3 cursor-pointer" @click="getMonth(range[0])" v-text="range[1]"></button>
							</li>
						</ul>
					</div>
				</div>
				<div class="calhead mt-1/8">
					<nav>
						<div class="flex-0" v-if="nav[0]">
							<button class="flex items-center justify-between" type="button" @click="getMonth(nav[0])">
								<svg class="mx-1/8" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path transform="rotate(180 10 10)" d="M2 5v10l8-1v4l8-8-8-8v4z" /></svg>
								<div class="f7">{{ navNames.prev.substr(0,3) }}</div>
							</button>
						</div>
						<div v-else><span></span></div>
						<div class="font-head f6 flex-1 uppercase" v-text="navNames.current"></div>
						<div class="flex-0" v-if="nav[2]">
							<button  class="flex items-center justify-between" type="button" @click="getMonth(nav[2])">
								<div class="f7">{{ navNames.next.substr(0,3) }}</div>
								<svg class="mx-1/8" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 5v10l8-1v4l8-8-8-8v4z" /></svg>
							</button>
						</div>
						<div v-else><span></span></div>
					</nav>
					<ul>
						<li>Sun</li>
						<li>Mon</li>
						<li>Tue</li>
						<li>Wed</li>
						<li>Thu</li>
						<li>Fri</li>
						<li>Sat</li>
					</ul>
				</div>
				<div class="caldates">
					<ul>
						<li v-for="(date, index) in thisMonth" :class="date[0]">
							<div v-if="date[1] == -1" :class="hoverTail(index)" class="outside" :style="hoverTailPosition(index)" v-text="date[0]>0?date[0]:null"></div>
							<button type="button" v-if="date[1] == 1" :class="[ hoverTail(index), {'hoverhead': hoveredDate == index} , {'fade': hoveredDate && hoveredDate != index}]" :style="hoverTailPosition(index)" v-text="date[0]"  @mouseover="hoverCalc(index)" @mouseout="unHoverCalc" @click="selectDate(date, index)"></button>
							<div v-if="date[1] == 0" :class="hoverTail(index)" class="nodate" :style="hoverTailPosition(index)" v-text="date[0]>0?date[0]:null"></div>
						</li>
					</ul>
				</div>
				<button class="itinerary" v-if="mobileButton" @click="goToItinerary">Head South <svg class="inline-block" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 5v10l8-1v4l8-8-8-8v4z" /></svg>
</button>
			</div>
		</div>
	</span>
</template>

<script>

	import axios from 'axios';


	export default {
		props:['dealId', 'dealNights', 'button'],
		data() {
			return {
				open: false,
				nav: [0,1,2],
				year: 0,
				thisMonth: [],
				months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				hoveredDate: null,
				date: null,
				mobileButton: false,
				loadingNext: false,
				ranges: []
			}
		},
		watch: {
			open() {
				if (this.open) {
					document.querySelector('header').setAttribute('style', 'display: none')
					document.querySelector('.navbutton').setAttribute('style', 'display: none')
				} else {
					document.querySelector('header').setAttribute('style', 'display: block')
					document.querySelector('.navbutton').setAttribute('style', 'display: block')
				}
			}
		},
		methods: {
			getMonth(month = null) {
				this.hoveredDate = null;
				this.mobileButton = false;
				axios.post('/api/calmonth', { deal_id: this.dealId, month: month })
				.then(response => {
					this.year =  (response.data.year)
					this.nav =  (response.data.nav)
					this.thisMonth = (response.data.days)
					this.ranges = (response.data.ranges)
				})
				.catch(() => {
					alert('failure');
				});

			},
			openCalendar() {
				this.open = true
				this.getMonth()
			},
			hoverCalc(date){
				this.hoveredDate = date;
			},
			unHoverCalc(){
				this.hoveredDate = null;
			},
			hoverTail(index){
				if (this.hoveredDate && this.hoveredDate < index & this.hoveredDate+this.dealNights >= index)
				return 'hovertail'
			},
			hoverTailPosition(index){
				if (!this.hoveredDate){
					return null;
				}
				if (index == this.hoveredDate){
					return 'background-position: 0 0'
				}
				if (index == this.hoveredDate+1){
					return 'background-position: -40px 0'
				}
				if (index == this.hoveredDate+2){
					return 'background-position: -80px 0'
				}
				if (index == this.hoveredDate + this.dealNights){
					return 'border-radius: 0 99px 99px 0'
				}
			},
			redirectUrl(date){
				let month = this.nav[1]==12?12:(this.nav[1]%12);
				return '/booking-search/prepackage/'+date[2]+'/'+this.year+'-'+month+'-'+date[0]
			},
			loadModal(){
				Alpine.store('alpineModal', '<span class="left">FINDInG YoUR</span><span class="right">TRUE NoRTH</span>')
				// let modal = document.getElementById('modal')
				// modal.removeAttribute("style")
				// modal.classList.add('fadeinmodal')
				this.loadingNext = true;
			},
			selectDate(date, index){
				this.date = date
				if (hasTouch) {
					this.hoverCalc(index)
					this.mobileButton = true;
				} else {
					this.goToItinerary()
				}
			},
			goToItinerary(){
				this.loadModal()
				axios.post('/api/eventtracetouch', {type: 'Button', value: 'Deal Date Selected: '+this.date})
				setTimeout(() => {
					window.location.href = this.redirectUrl(this.date)
				}, 1000)
			}
		},
		computed: {
			navNames() {
				return {
					prev: this.months[monthArrayValue(this.nav[0])],
					current: this.months[monthArrayValue(this.nav[1])],
					next: this.months[monthArrayValue(this.nav[2])]
				}
			}
		}

	}



	function monthArrayValue(value){
		value = value+12;
		value = value%12;
		if (value == 0){
			value=12;
		}
		return value-1;
	}


</script>

<style lang='less'>

@import '../../../../public/bower_components/3l/3L/3L.less';
@import '../../less/variables';
@import '../../less/helpers';

@keyframes pre_fadein {
	from{
		opacity: 0;
	}
	to{
		opacity: 1;
	}
}

@keyframes itinerarySlideUp{
	from{
		opacity: 0;
		transform: translate(0, 10px);
	}
	to{
		opacity: 1;
		transform: translate(0, 0);
	}
}

.cal_container{
	button {
		margin: 0 !important;
	}
	// z-index: 301;
	transform: translate3d(0,0,0);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	max-width: auto;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	font-size: @f8;
	line-height: @magic;
	font-family: @fontread;
}


button.link, button.itinerary{
	display: inline;
	border: 0;
	white-space: wrap;
	font: inherit;
	background: none;
	cursor: pointer;
	color: @blue;
	border-bottom: 1px @blue dotted;
	padding: 0;
	&:hover{
		color: @sunrise;
	}
}
button.itinerary{
	.action;
	position: absolute;
	left: 50%;
	margin-left: -69px;
	display: block;
	padding: @magic/4;
	opacity: 0;
	animation: itinerarySlideUp 0.3s forwards ease-out 0.8s;
	svg{
		top:2px;
	}
}
.calendar_panel{
	background: white;
	width: 308px;
	height: auto;
	border-radius: @magic/8;
	padding: @magic/2;
}

.calhead{
	nav{
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-bottom: @magic/4;
		&>*{
			flex-basis: 3.5em;
			text-align: center;
		}
		.monthtitle{
			color: @text;
			flex: 1.5;
		}
		button, span{
			.newbutton(@verylightgrey);
			display: block;
			width: 100%;
			height: 100%;
		}
		button{
			.newbutton(@cyan);
		}
	}
	ul{
		display: flex;
		margin: 0;
		padding: 0;
		li{
			display: block;
			text-align: center;
			flex:1;
			margin:0;

			font-size: @f9;
			line-height: @magic*0.75;
			font-family: @fontread;

			color: @lightgrey;
		}
	}
}

svg.closebutton{
	position: absolute;
	top: -@magic/2;
	right: @magic/2;
	width: @magic;
	height: @magic;
	fill: @lightgrey;
	cursor: pointer;
}

.caldates ul{
	display: flex;
	flex-wrap: wrap;
	margin: 0;
	padding: 0;
	list-style: none;
	li{
		margin: 0;
		width: 40px;
		height: 40px;
		button, div{
			flex: 1;
			display: flex;
			font-family: @fontread;
			font-size: @f9;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 100%;
			border: 0;
			background-size: auto 100%;
			color: @grey;
		}
		button{
			cursor: pointer;
			appearance: none;
			color: @blue;
			background-image: url('/svg/green_button_40.svg');
			background-position: center ;
			background-repeat: no-repeat;
			background-size: 40px, 0;
			border-radius: @magic/4;
			box-shadow: inset 0 0 0 20px transparent;
			&:after{
				transition: opacity 0.3s;
				opacity: 0;
				content: '';
				width: 100%;
				height: 100%;
				top: 0;
				left:0;
				position: absolute;
				background-image: url('/svg/yellow_button_40.svg');
			}
		}

		.fade:after{
			opacity: 1;
		}
		.outside{
			background: #F8F8F8;
			color: @verylightgrey;
		}
		.nodate{
			background-image: url('/svg/no_date.svg');
		}
		.hovertail{
			opacity: 0;
			animation: 0.3s pre_fadein forwards;
			background-image: url('/svg/beach_illust.svg');
			background-position: -120px 0px;
			background-size: auto 40px;
			background-repeat: repeat;
			border-radius: 0;
			color: white;
			box-shadow: none !important;
			&:after{
				content: none;
			}
		}
		button.hoverhead{
			border-radius: 99px 0 0 99px;
			box-shadow: none;
			color: white;
			background-image: url('/svg/beach_illust.svg');
			background-size: auto 40px;
			&:after{
				content: none;
			}
		}
	}
}


</style>


